import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import authProvider from '../../../../core/AuthenticationProvider'
import { getCurrentPlan } from '../../../dashboard/components/currentPlan/store/thunk'
import EventEmitter, { SHOW_POPUP_UPGRADE } from '../../../helpers/EventEmitter'
import { PopupUpgrade as PopupViewPlan } from '../../../userManagement/subscriptionPayment/common/popupUpgrade'
import { Element } from '../../html/element'
import { PopupAction } from '../PopupAction'
import './i18n'

export const PopupUpgrade = () => {
  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)

  const [isShow, setIsShow] = useState(false)
  const [isShowViewPlan, setIsShowViewPlan] = useState(false)

  useEffect(() => {
    const showPopup = () => {
      setIsShow(true)
    }
    EventEmitter.subscribe(SHOW_POPUP_UPGRADE, showPopup)
    return () => {
      EventEmitter.unsubscribe(SHOW_POPUP_UPGRADE, showPopup)
    }
  }, [])

  const handleClose = () => {
    setIsShow(false)
  }

  const handleSubmit = () => {
    setIsShowViewPlan(true)
    setIsShow(false)
  }

  useEffect(() => {
    authProvider
      .getUser()
      .then((user) => {
        if (user && !user?.profile?.user_id) {
          dispatch(getCurrentPlan())
        }
      })
      .catch(() => {})
  }, [locale])

  return (
    <>
      <PopupAction
        isShow={isShow}
        title={'common.popup.popupUpgrade.TITLE'}
        btnSubmit={{
          label: 'common.popup.popupUpgrade.VIEW_PLANS_AND_PRICING',
          isI18n: true,
          event: handleSubmit,
        }}
        btnCancel={{
          label: 'common.popup.popupUpgrade.NOT_NOW',
          isI18n: true,
          event: handleClose,
        }}
        footerStyle={{ justifyContent: 'center' }}
        handleClose={handleClose}
      >
        <Element style={{ color: '#3A414B' }}>
          <Translate value={'common.popup.popupUpgrade.DESC'} />
        </Element>
      </PopupAction>
      {isShowViewPlan && (
        <PopupViewPlan isShow={isShowViewPlan} setIsShow={setIsShowViewPlan} />
      )}
    </>
  )
}
